const documentActionType = {
    SET_DOCUMENT_DROP_DOWN_ITEMS:  'SET_DOCUMENT_DROP_DOWN_ITEMS',
    SET_BOX_NUMBER: 'SET_BOX_NUMBER'
}

export default documentActionType;
